export enum NotificationItemType {
  Appointment,
  AppointmentRequest,
  Referral
}
